<template>
  <toggle-section
    section="document_retrieval"
    data-cy="document-retrieval-section"
    chevron-position="right"
    :is-open="isOpen"
    @toggle="isOpen = !isOpen"
  >
    <template #titleSection>
      <lf-h4>{{ $t("DEALS.DOCUMENTS.DOCUMENT_RETRIEVAL") }}</lf-h4>
    </template>
    <template #content>
      <json-viewer-wrapper
        :data="data"
        :provider-name="currentProviderName"
        service-name="clear"
        :service-type="isKyc ? ServiceType.kyc : ServiceType.kyb"
      />
      <corporate-filing
        v-if="corporateFilingData"
        :data="corporateFilingData"
      />
    </template>
  </toggle-section>
</template>
<script setup lang="ts">
import { computed, onMounted, ref } from "vue";

import isEmpty from "lodash/isEmpty";

import { convertToArray } from "@/helpers/common";
import { useJsonTreeStateStore } from "@/stores/serviceJsonViewer";

import ToggleSection from "@/components/ToggleSection.vue";
import CorporateFiling from "@/components/deals/dataServices/components/clear/CorporateFiling.vue";
import JsonViewerWrapper from "@/components/deals/dataServices/jsonViewer/JsonViewerWrapper.vue";
import LfH4 from "@/components/ui/text/LfHeading4.vue";

import type { CorporateFilingItem } from "@/models/commercialData/clear/ClearIdConfirmBusiness";
import type { JsonViewerData } from "@/models/jsonViewer";

interface Props {
  data: JsonViewerData | null;
  providerName: string;
  isKyc?: boolean;
}

enum ServiceType {
  kyb = "kyb_document_retrieval",
  kyc = "kyc_document_retrieval",
}

const props = withDefaults(defineProps<Props>(), { isKyc: false });

const serviceJsonTreeStateStore = useJsonTreeStateStore();

const isOpen = ref(true);

const currentProviderName = computed(() => {
  const type = props.isKyc ? ServiceType.kyc : ServiceType.kyb;
  return `${props.providerName}_${type}`;
});

const corporateFilingData = computed(() => {
  if (props.isKyc || isEmpty(props.data)) {
    return null;
  }

  return convertToArray(props.data)
    .map(
      (item) =>
        item.ResultGroup.RecordDetails.DocumentRetrievalResponseDetail
          .CorporateRecord
    )
    .filter(Boolean) as CorporateFilingItem[];
});

onMounted(() => {
  if (props.data) {
    serviceJsonTreeStateStore.updateServiceJsonStatus(
      currentProviderName.value
    );
  }
});
</script>
